<template>
  <v-card flat>
    <v-list-item two-line class="pt-0">
      <v-list-item-content>
        <v-list-item-title class="headline"
          >Mes recherches avancées
        </v-list-item-title>
        <v-list-item-subtitle
          >Veuillez sélectionner une recherche pour y
          accéder</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <datasource-table :datasource="datasource">
        <template #item.titre="{item}">
          <a @click="afficher(item)">
            {{ item.titre }}
          </a>
        </template>
      </datasource-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  data() {
    const datasource = new Datasource('recherche/avancee/mes', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['titre'],
      descending: [false],
      fields: [
        {
          text: 'Titre',
          value: 'titre',
          sortable: true,
        },
      ],
    });

    return {
      datasource,
    };
  },

  mounted() {
    this.datasource.refresh();
  },

  methods: {
    afficher(sauvegarde) {
      this.$router.push({
        name: 'recherche/rechercheavancee',
        params: {
          infoRecherche: sauvegarde,
        },
      });
    },
  },
};
</script>
